import { GraphUtils } from '@helpers/graph.helper';
import { Sensor } from '../sensor/sensor';
import { Router } from '@angular/router';
import { UtilsHelper } from '@helpers/utils.helper';

export class PhAttribute extends Sensor {
  public phChart: any;
  private phSensor: any[];
  public iconsToDisplay: { icon: string, type: number }[] = [];

  constructor(router: Router, url: string, alertsActive: boolean) {
    super(router, url, alertsActive);
    this.phChart = null;
    this.phSensor = [];
  }

  private ensureArraySize(arr: any[], position: number): void {
    while (arr.length <= position) {
      arr.push([]);
    }
  }

  public prepareData(): void {
    const iconMap = new Map<string, { icon: string, type: number }>();
    for (const element of this.data) {
      const date = new Date(element.date);
      const timestamp = GraphUtils.getDateUtc(date);
      const position = element.position;
      const sensorInfo = UtilsHelper.nameSensor(element.type);
      const icon = sensorInfo.icon;
      if (!iconMap.has(icon)) {
        iconMap.set(icon, {
          icon,
          type: element.type
        });
      }

      this.ensureArraySize(this.phSensor, position);
      this.phSensor[position].push([timestamp, element.ph]);
    }
    this.iconsToDisplay = Array.from(iconMap.values());
  }

  public setCharts(): void {
    const filteredPh = this.phSensor.filter(series => series.length > 0);

    const positionNodePh = this.phSensor
      .map((item, index) => (item.length > 0 ? index + 1 : -1))
      .filter(index => index !== -1);

    this.phChart = this.getConfigChar(
      'ph',
      this.getChartSeriesNewNode('Sensor', filteredPh, positionNodePh),
      this.getRanges('ph'),
      this.getLimits('ph')
    );
  }

  public hasPhSensor(pos: number): boolean {
    const index = pos - 1;
    return (
      index >= 0 &&
      index < this.phSensor.length &&
      this.phSensor[index].length > 0
    );
  }

  public getPhSensor(pos: number): any {
    const index = pos - 1;
    if (index >= 0 && index < this.phSensor.length) {
      const sensorData = this.phSensor[index];
      if (sensorData.length > 0) {
        return sensorData[sensorData.length - 1][1] ?? null;
      }
    }
    return null;
  }

  public static getVariables(): any[] {
    return [
      { title: 'pH', value: 'ph' }
    ];
  }
}
